import RatingIcon from "./icon-1.webp";

export { RatingIcon };